import { useEffect, useState } from 'react'
import { IconAlertCircle, IconRefresh } from '@tabler/icons-react'
import { SidebarModule } from '@/config/permissions'
import { AgentService } from '@/services/agent.service'
import { useModuleAccess } from '@/hooks/use-module-access'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import { Skeleton } from '@/components/ui/skeleton'
import { Main } from '@/components/layout/main'
import { AgentsDialogs } from './components/agents-dialogs'
import { AgentsPrimaryButtons } from './components/agents-primary-buttons'
import { columns } from './components/columns'
import { DataTable } from './components/data-table'
import AgentsProvider from './context/agents-context'

export default function Agents() {
  useModuleAccess(SidebarModule.AI_AGENTS)
  const [agents, setAgents] = useState<any[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const loadAgents = async () => {
    setIsLoading(true)
    setError(null)
    try {
      const data = await AgentService.list()
      setAgents(data)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erro ao carregar agentes')
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    loadAgents()
  }, [])

  return (
    <AgentsProvider refetch={loadAgents}>
      <Main>
        <div className='mb-2 flex flex-wrap items-center justify-between gap-x-4 space-y-2'>
          <div>
            <h2 className='text-2xl font-bold tracking-tight'>Agentes de IA</h2>
            <p className='text-muted-foreground'>
              Gerencie seus agentes conversacionais de inteligência artificial.
            </p>
          </div>
          <AgentsPrimaryButtons />
        </div>
        <div className='-mx-4 flex-1 overflow-auto px-4 py-1 lg:flex-row lg:space-x-12 lg:space-y-0'>
          {isLoading ? (
            <div className='space-y-3'>
              <Skeleton className='h-12 w-full' />
              <Skeleton className='h-16 w-full' />
              <Skeleton className='h-16 w-full' />
              <Skeleton className='h-16 w-full' />
            </div>
          ) : error ? (
            <Alert variant='destructive'>
              <IconAlertCircle className='h-4 w-4' />
              <AlertTitle>Erro</AlertTitle>
              <AlertDescription className='flex items-center justify-between'>
                <span>{error}</span>
                <Button variant='outline' size='sm' onClick={loadAgents}>
                  <IconRefresh className='mr-2 h-4 w-4' />
                  Tentar novamente
                </Button>
              </AlertDescription>
            </Alert>
          ) : (
            <DataTable data={agents} columns={columns} />
          )}
        </div>
      </Main>
      <AgentsDialogs onDeleteSuccess={loadAgents} />
    </AgentsProvider>
  )
}
